// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"be3a0e75","82":"ae9743cf","417":"3676a354","607":"76160839","641":"cdb35a4c","643":"5461e518","993":"ecb4158a"}[chunkId] + ".chunk.js";
};